import { render } from "./OpenMarketRegistrationView.vue?vue&type=template&id=599e6234&scoped=true&ts=true"
import script from "./OpenMarketRegistrationView.vue?vue&type=script&lang=ts"
export * from "./OpenMarketRegistrationView.vue?vue&type=script&lang=ts"

import "./OpenMarketRegistrationView.vue?vue&type=style&index=0&id=599e6234&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599e6234"]])

export default __exports__